/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Slug_LabelInputs */

const vi_shop_slug_label = /** @type {(inputs: Shop_Slug_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đường dẫn (slug)`)
};

/**

* @param {Shop_Slug_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_slug_label = /** @type {((inputs?: Shop_Slug_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Slug_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_slug_label(inputs)
});